import React from "react";
import { Row, Col, Button } from "reactstrap";
import styles from "./Tags.module.scss";

const Tags = ({ tags = [] }) => {
  return (
    <>
      <h4>This resource appears in:</h4>
      <div className={styles.containerButtons}>
        {tags.map((tag, index) => (<Button
          key={index}
          tag='a'
          className={styles.buttonTag}
          href={`/experience-tag/${tag.slug}`}
        >
          {tag.name}
        </Button>))}
      </div>
    </>
  );
};

export default Tags;
